import AnimatedSection from './section';
import selectors from './animation-selectors';

export {
  selectors,
  AnimatedSection,
};



// WEBPACK FOOTER //
// ./scripts/animation/index.js